import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface GenerateUserPushModuleAnswersSynthesisParams {
	readonly coacheeId: string;
}

@Injectable({ providedIn: 'root' })
export class GenerateUserPushModuleAnswersSynthesisApiMutation extends ApiMutation<
	void,
	GenerateUserPushModuleAnswersSynthesisParams
> {
	client = 'content';
	document = gql`
		mutation GenerateUserPushModuleAnswersSynthesis($coacheeId: UUID!) {
			generateUserPushModuleAnswersSynthesis(coacheeId: $coacheeId)
		}
	`;
	method = 'generateUserPushModuleAnswersSynthesis';
}
